import { Sparkle } from "lucide-react";
import { useLang } from "@/i18n";

const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div className="overflow-hidden border-y border-[#EBDDC6]/70 bg-[#FFFBF3] py-5" data-testid="marquee-ribbon">
      <div className="animate-marquee flex w-max items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display px-8 text-xl italic text-[#7A6753] sm:text-2xl">{item}</span>
            <Sparkle size={13} className="text-[#E07A2B]" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
